import React from "react"
import { ParametrosClienteFielContextProvider } from "../ConfiguracaoDeliveryFornecedor/context/ParametrosClienteFielContextProvider"
import { IntegracaoWhatsappContextProvider } from "./context/IntegracaoWhatsappContextProvider"
import { IntegracaoWhatsapp } from "./IntegracaoWhatsapp"

export function Index() {
    return (
        <IntegracaoWhatsappContextProvider>
            <ParametrosClienteFielContextProvider>
                <IntegracaoWhatsapp />
            </ParametrosClienteFielContextProvider>
        </IntegracaoWhatsappContextProvider>
    )
}
